import video_interactions_module from './video-interactions.js';
import video_global_vars_module from './variables.js';

var video_scaling_module = {};

video_scaling_module.size_video = function ($video_container) {
  
  var is_desktop = window.matchMedia('(min-width: 1025px)').matches;  
  var window_width = $(window).width();
  var window_height = $(window).height();

  if (is_desktop) {

    $video_container.css('max-height', window_height);
    $video_container.find('video').css('max-height', window_height);        

  } else {

    $video_container.css('max-height', '');
    $video_container.find('video').css('max-height', '');                 

  }

}

video_scaling_module.full_screen_handler = function() {


  video_global_vars_module.videos_container.each(function(index,value){
  
    var video_id = $(this).data('video-id'),
        video_argument = '#' + video_id,
        $video = $(video_argument),
        $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
        $video_object = $video.get(0),
        $play_button = $('.js-play-pause[data-video-id="' + video_id +'"]');

    if ($video.hasClass(video_id)) {

      video_interactions_module.pause_video($video_object, $play_button, $video_overlay);

    }    

  });

};

export default video_scaling_module